import AutoPartnerRouter from './auto-partner-router';

export default AutoPartnerRouter;
